var showEmpty = function() {
	$(".compare").hide();
	$(".compare--empty").show();
}

var showProducts = function() {
	$(".compare").show();
	$(".compare--empty").hide();
};

CompareItems.on("add", function(item) {

	// Load with ajax

	showProducts();

});

CompareItems.on("remove", function(item) {

	if(!item.isIndex) {
		var td    = $("td[data-id=\"" + item.id + "\"]");
		var tr    = td.closest("tr").find("td");
		var tbody = tr.closest("tbody");
		var index = tr.index(td);

		td.remove();
		tbody.next("tbody").find("tr > td:nth-child(" + (index + 1) + ")").remove();

		if (CompareItems.empty()) {
			showEmpty();
		}
	}
});

CompareItems.on("change", function() {

    $(".js-compare-items-count").text(CompareItems.count());

});

var tooltip = $('.btn-compare__tooltip');

$(".btn-remove").on("click", function(e) {

	e.preventDefault();
	e.stopImmediatePropagation();

	var _this = $(this);
	var id = _this.attr("data-id");
	var index = -1;
	var items = CompareItems.items;
	
	for (var i = 0, len = items.length; i < len; i++) {
		if (items[i].id == id) {
			index = i;
			break;
		}
	}
	CompareItems.remove(index, _this.parent().hasClass('product__compare'));

	_this.removeClass('js-remove-compare-item').addClass('js-data-add-to-compare');

	tooltip.each(function(i,e) {
		if($(e).data('id') == _this.data('id')) {
			compareTimer = setTimeout(function() {
				$(e).text('Добави за сравнение');
			}, 2000);
			
		}
	});

});